"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./FormLabel.scss");
var FormLabel = function (props) { return (react_1.default.createElement("label", { htmlFor: props.htmlFor, "data-dusk": props.dusk, className: "form-label" }, props.label)); };
exports.default = FormLabel;
//# sourceMappingURL=index.js.map